import React from "react";
import { SortableElement } from "react-sortable-hoc";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

class SortableItem extends React.Component {
  state = {
    isOpen: false
  };

  render() {
    const { props } = this;
    let { value } = props;

    let style = value.url
      ? {
          backgroundImage: "url(" + value.url + ")"
        }
      : {
          backgroundImage: "url(" + value.preview + ")"
        };

    let filesize = (value.bytes / 1000000).toFixed(1);

    return (
      <div className="dropzone-item">
        {this.state.isOpen && (
          <Lightbox
            mainSrc={value.url}
            onCloseRequest={() =>
              this.setState({
                isOpen: false
              })
            }
          />
        )}
        <div
          className={`image-preview ${this.previewClass}`}
          style={style}
          onClick={() => this.setState({
            isOpen: true
          })}
        />
        <div className="filename">
          {value.original_filename} - {filesize}mb
        </div>
        <div className="actions ml-auto">
          <button
            className="btn btn-danger btn-sm"
            type={"button"}
            id={"Popover" + props.sortIndex}
            onClick={() => {
              props.removeItem(props.sortIndex);
            }}
          >
            DELETE
          </button>
        </div>
      </div>
    );
  }
}

export default SortableElement(SortableItem);



// WEBPACK FOOTER //
// ./src/system/fields/FileUpload/SortItem.jsx